module.exports = __webpack_public_path__ + "img/email_primary.85ef699e.svg";